// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1z4hp","productName":"Table_productName__35F2Z"};